import CryptoJS from "crypto-js";

// Constants
let ENCRYPTION_KEY = ''; // Replace with your encryption key
const fetchEncryptionKey = async()=>{
  // Fetch from backend

}

// Custom hook for encryption
const encrypt = (dataToEncrypt) => {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
  const iv = CryptoJS.lib.WordArray.random(16); // For AES-256-CBC, IV length is 16 bytes
  const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const ivHex = iv.toString(CryptoJS.enc.Hex);
  const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  return ivHex + ":" + encryptedHex;
};

const decrypt = (dataToDecrypt) => {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
  const parts = dataToDecrypt.split(":");
  const ivBase64 = parts[0];
  const encryptedBase64 = parts[1];
  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

const decryptData = (encryptedData, iv) => {
  if (!encryptedData || !iv) {
    throw new Error('Both encryptedData and iv parameters are required');
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
    const ivParsed = CryptoJS.enc.Base64.parse(iv);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: ivParsed,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
      throw new Error('Decryption failed - invalid encrypted data or IV');
    }

    return JSON.parse(decryptedText);
  } catch (error) {
    if (error instanceof SyntaxError) {
      throw new Error('Decrypted data is not valid JSON');
    }
    throw error;
  }
};
export { encrypt, decrypt, decryptData };
